import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CompanyClient } from '../clients/oreg-api/company.client';
import { CreateCompanyModel } from '../models/create-company.model';
import { CreateWorksiteModel } from '../models/create-worksite.model';
import { ListWorksite } from '../models/list-worksite.model';

@Injectable({ providedIn: 'root' })
export class CompaniesCommand {
  constructor(private companyClient: CompanyClient) {}

  public createCompanyAndWorksite(
    company: CreateCompanyModel,
    worksite: CreateWorksiteModel,
  ): Observable<ListWorksite> {
    return this.companyClient.createCompanyAndWorksite(company, worksite);
  }
}
